













































































import { MenuItem, MenuItemGroup, Submenu, Tag, Badge } from "amumu-ui"
import { defineComponent } from "@vue/composition-api"
import { MenuItemType, FormatedMenuItemType } from "../../types"

const DELAY_TIME = 100

interface SideBarItemProps {
  menuItem: FormatedMenuItemType
  activeIds: string[]
}
export default defineComponent<SideBarItemProps>({
  name: "SidebarItem",
  components: {
    "ui-menu-item": MenuItem,
    "ui-menu-item-group": MenuItemGroup,
    "ui-submenu": Submenu,
    "ui-tag": Tag,
    "ui-badge": Badge,
  },
  props: {
    menuItem: {
      type: Object,
      required: true,
    },
    activeIds: {
      type: Array,
      required: true,
    },
    level: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const selectMenuComponent = (list: MenuItemType | FormatedMenuItemType) => {
      if (list.subMenu) {
        return "ui-submenu"
      }
      return "ui-menu-item"
    }
    const isActiveMenu = (id: string) => {
      return props.activeIds.includes(id)
    }

    return {
      DELAY_TIME,
      isActiveMenu,
      selectMenuComponent,
    }
  },
})
